export default "__VITE_ASSET__bb319151__"